import React from 'react';

export type CategoryCardAccent = 'purple' | 'blue' | 'green' | 'amber';

export type CategoryCardTab = 'Business' | 'Employment' | 'Customers' | 'Suppliers';

/** Colour used for each category's icons, shared by the category and workflow cards. */
export const CATEGORY_CARD_ACCENTS: Record<CategoryCardTab, CategoryCardAccent> = {
  Business: 'purple',
  Employment: 'blue',
  Customers: 'green',
  Suppliers: 'amber',
};

export type CategoryCardProps = {
  /** Base id used for click tracking (Google Analytics). */
  id: string;
  title: string;
  /** Secondary line shown under the title in a smaller font (e.g. an employee's position). */
  subtitle?: string;
  countLabel?: string;
  description?: string;
  icon: React.ReactNode;
  accent: CategoryCardAccent;
  onClick?: () => void;
  hasNewLabel?: boolean;
  hasFreeLabel?: boolean;
  previewBlock?: React.ReactNode;
  actions?: React.ReactNode;
};

export type CategoryCardGridProps = {
  id?: string;
  children: React.ReactNode;
};
